export const getCurrentDateWeek = (): number => {
  const dt = new Date();
  // Create a copy of the provided date object to avoid modifying the original
  let tdt = new Date(dt.valueOf());
  // Calculate the day number (0 for Sunday, 1 for Monday, ..., 6 for Saturday) and adjust it to have Monday as the first day of the week
  let dayn = (dt.getDay() + 6) % 7;
  // Adjust the copied date object to represent the Thursday of the current week
  tdt.setDate(tdt.getDate() - dayn + 3);
  // Store the value of the first Thursday of the year
  let firstThursday = tdt.valueOf();
  // Set the copied date object to January 1st of the current year
  tdt.setMonth(0, 1);
  // If January 1st is not a Thursday, find the date of the first Thursday of the year
  if (tdt.getDay() !== 4) {
    tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
  }
  // Calculate the ISO 8601 week number based on the difference between the value of the first Thursday and the current Thursday, divided by the number of milliseconds in a week
  return 1 + Math.ceil((firstThursday - tdt.valueOf()) / 604800000);
};
